export const TRACK_INTEGRATIONS = {
  connectedAccount: (provider: string) => `[Integration] Successfully connected ${provider}`,
  hasNoAccounts: (provider: string) => `[Integration] No ${provider} accounts to connect`,
  failedToConnect: (provider: string) => `[Integration] Failed to connect ${provider}`,
};
